import { EnvironmentInjector, inject, Injectable } from '@angular/core';
import { UserStore,SIGN_IN_STATUS } from 'journey-store';

@Injectable({ providedIn: 'root' })
export class AuthService {
    // private userProfile:UserProfile=null;
    private userStore = inject(UserStore);
    // private injector =inject(EnvironmentInjector);

    // constructor(){
    //     effect(()=>{
    //         this.userProfile = this.userStore.profile();
    //     });
    // }


    // private _authenticated: boolean = false;
    // private _httpClient = inject(HttpClient);
    // private _userService = inject(UserService);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    // set accessToken(token: string) {
    //     localStorage.setItem('accessToken', token);
    // }

    // get accessToken(): string {
    //     return localStorage.getItem('accessToken') ?? '';
    // }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string):boolean {
        return true;
        //return this._httpClient.post('api/auth/forgot-password', email);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(password: string):boolean {
        return true;
        // return this._httpClient.post('api/auth/reset-password', password);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    async signIn(credentials: { email: string; password: string }): Promise<SIGN_IN_STATUS>{
        // Throw error, if the user is already logged in
        if (this.userStore.profile()) {
            return SIGN_IN_STATUS.ALREADY_SIGNED_IN;
        }else{
            return await this.userStore.signIn(credentials.email,credentials.password);
        }

        // return this._httpClient.post('api/auth/sign-in', credentials).pipe(
        //     switchMap((response: any) => {
        //         // Store the access token in the local storage
        //         this.accessToken = response.accessToken;

        //         // Set the authenticated flag to true
        //         this._authenticated = true;

        //         // Store the user on the user service
        //         this._userService.user = response.user;

        //         // Return a new observable with the response
        //         return of(response);
        //     })
        // );
    }

    // /**
    //  * Sign in using the access token
    //  */
    // signInUsingToken(): Observable<any> {
    //     // Sign in using the token
    //     return this._httpClient
    //         .post('api/auth/sign-in-with-token', {
    //             accessToken: this.accessToken,
    //         })
    //         .pipe(
    //             catchError(() =>
    //                 // Return false
    //                 of(false)
    //             ),
    //             switchMap((response: any) => {
    //                 // Replace the access token with the new one if it's available on
    //                 // the response object.
    //                 //
    //                 // This is an added optional step for better security. Once you sign
    //                 // in using the token, you should generate a new one on the server
    //                 // side and attach it to the response object. Then the following
    //                 // piece of code can replace the token with the refreshed one.
    //                 if (response.accessToken) {
    //                     this.accessToken = response.accessToken;
    //                 }

    //                 // Set the authenticated flag to true
    //                 this._authenticated = true;

    //                 // Store the user on the user service
    //                 this._userService.user = response.user;

    //                 // Return true
    //                 return of(true);
    //             })
    //         );
    // }

    /**
     * Sign out
     */
    async signOut(){
        await this.userStore.signOut();
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: {
        name: string;
        email: string;
        password: string;
        company: string;
    }){
        // return this._httpClient.post('api/auth/sign-up', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: {
        email: string;
        password: string;
    }){
        // return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    async check(){
        // return true;
        // return runInInjectionContext(this.injecto r, () => {
        try{    
            return this.userStore.loadUser(); // ✅ safe even if store uses inject()
        }catch(e){
            console.error('Error loading user',e);
            return false;
        }
        //   });

    }
}
